import { computed, observable } from "mobx";
import * as DocumentReader from "../DocumentReader";
import { IDocumentsView } from "../Document/DocumentsView";
import { FavouriteDataStore } from "../Stores/FavouriteDataStore";
import { Strings } from "../Stores/StringsStore";
import { FilesUIStore } from "../Stores/FilesUIStore";
import { DialogStore } from "../Stores/DialogStore";

export class FavouriteUIStore extends FilesUIStore implements IDocumentsView {

	/*No Result message*/
	noResultMsg: string = Strings.favorites.favouritePlaceholderTextforEmptyResult;

	@computed get scrollLock(): boolean {
		return (this.searchResult.documents.length >= this.skip + this.top)
	}

	setFileVariants(query: DocumentReader.DocumentQuery): void {
		if (FavouriteDataStore.favouriteDocs.length > 0) {
			query.fileVariants.push(...FavouriteDataStore.favouriteDocs);
		}
		else {
			query.fileVariants = [];
		}
	}

	/**
	 * Triggers the search
	 */
	public triggerSearch(resetPagination?: boolean, isScrolling: boolean = false) {
		if (!this.isBusy) {
			this.isBusy = true;
			let query = this.currentDocumentQuery;
			DocumentReader.queryDocumentsAsync(query).then(result => {
				if (!isScrolling) { this.searchResult.headers.replace(result.headers); }
				if (this.skip == 0) {
					this.searchResult.documents.replace(result.documents);
				}
				else {
					this.searchResult.documents.push(...result.documents);
				}
				this.isBusy = false;
			}).catch(error => {
				DialogStore.showError(Strings.general.errorDialogTitle, error);
				this.isBusy = false;
			});
		}
	}

	/**
	 * Creates the current DocumentQuery object for triggering the search.
	 */
	get currentDocumentQuery(): DocumentReader.DocumentQuery {
		let query: DocumentReader.DocumentQuery = new DocumentReader.DocumentQuery();
		this.setFileVariants(query); 
		query.searchExpression = null;
		query.filters = null;
		query.skip = this.skip;
		query.top = this.top;
		query.sortBy = this.sortBy;
		return query;
	}
}
